// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const regionalSalesRepUri = "/api/sainc/regionalSalespersons";

export interface RegionalSalesRepModel {
    region: string;
    phone: string;
    name: string;
    email: string;
}

export interface RegionalSalesRepApiResponse extends BaseModel {
    regionalSalespersons: RegionalSalesRepModel[];
}

export async function getRegionalSalesRep() {
    try {
        const result = await get<RegionalSalesRepApiResponse>(`${regionalSalesRepUri}`);
        return {
            successful: true,
            data: result,
        };
    } catch (error) {
        return {
            successful: false,
            data: undefined,
        };
    }
}
